import {
  fetchGetProofRequestStarted,
  fetchGetProofRequestSuccess,
  fetchGetProofRequestError,
} from "./index";

// Gets a presentation exchange record
export const fetchGetProofRequest =
  (presentationExchangeId) => async (dispatch) => {
    try {
      dispatch(fetchGetProofRequestStarted());
      // GET request with set headers to get a single presentation exchange record with set headers
      const response = await fetch(
        `${process.env.REACT_APP_VERIFIER_URL}/present-proof/records/${presentationExchangeId}`,
        {
          method: "GET",
          headers: {
            "content-type": "application/json",
            apiKey: process.env.REACT_APP_VERIFIER_API_KEY,
            Authorization: `Bearer ${process.env.REACT_APP_VERIFIER_TOKEN}`,
          },
        }
      );
      // Gets the response of the GET request
      const data = await response.json();
      if (!response.ok) {
        throw data.error;
      }
      return dispatch(fetchGetProofRequestSuccess(data));
    } catch (error) {
      return dispatch(fetchGetProofRequestError());
    }
  };
